(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/contextual-menu.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/contextual-menu.js');
"use strict";


const _svs$ui = svs.ui,
  ReactItemsMenu = _svs$ui.ReactItemsMenu,
  ReactIcon = _svs$ui.ReactIcon;
const ItemsMenu = ReactItemsMenu.ItemsMenu,
  BallItem = ReactItemsMenu.BallItem;
class ContextMenu extends React.Component {
  renderXperten() {
    const _this$props = this.props,
      isOpenXperten = _this$props.isOpenXperten,
      drawNumber = _this$props.drawNumber;
    if (!isOpenXperten) {
      return null;
    }
    return React.createElement(svs.challenge.Xperten, {
      drawNumber: drawNumber,
      modalHeaderClass: "challenge-modal-header"
    });
  }
  renderTipsInfo() {
    const isOpenTipsinfo = this.props.isOpenTipsinfo;
    if (!isOpenTipsinfo) {
      return null;
    }
    return React.createElement(svs.challenge.Tipsinfo, {
      modalHeaderClass: "challenge-modal-header"
    });
  }
  renderGameGuide() {
    const _this$props2 = this.props,
      isOpenSpelguide = _this$props2.isOpenSpelguide,
      closeSpelguide = _this$props2.closeSpelguide;
    if (!isOpenSpelguide) {
      return null;
    }
    return React.createElement(svs.components.gameguide.ReactGameguide, {
      closeSpelguide: closeSpelguide,
      gameGuides: svs.challenge.data.config.gameGuide.guides,
      modalHeaderClass: "challenge-modal-header",
      product: svs.challenge.constants.PRODUCT_NAME
    });
  }
  render() {
    const _this$props3 = this.props,
      openXperten = _this$props3.openXperten,
      openTipsinfo = _this$props3.openTipsinfo,
      openSpelguide = _this$props3.openSpelguide;
    return React.createElement(React.Fragment, null, React.createElement(ItemsMenu, {
      branding: "challenge"
    }, React.createElement(BallItem, {
      borderOnly: true,
      label: "PIX!",
      onClick: () => {
        openXperten(true);
      }
    }, React.createElement(ReactIcon, {
      icon: "pix"
    })), React.createElement(BallItem, {
      borderOnly: true,
      label: "Tipsinfo",
      onClick: () => {
        openTipsinfo(true);
      }
    }, React.createElement(ReactIcon, {
      icon: "tipsinfo"
    })), React.createElement(BallItem, {
      borderOnly: true,
      label: "Spelguide",
      onClick: () => {
        openSpelguide(true);
      }
    }, React.createElement(ReactIcon, {
      icon: "tips"
    }))), this.renderXperten(), this.renderTipsInfo(), this.renderGameGuide());
  }
}
const mapStateToProps = state => ({
  isOpenSpelguide: state.openSpelguide,
  isOpenTipsinfo: state.openTipsinfo,
  isOpenXperten: state.openXperten
});
const _svs$challenge$action = svs.challenge.actions,
  openXperten = _svs$challenge$action.openXperten,
  openTipsinfo = _svs$challenge$action.openTipsinfo,
  openSpelguide = _svs$challenge$action.openSpelguide,
  closeSpelguide = _svs$challenge$action.closeSpelguide;
svs.challenge.ContextMenu = ReactRedux.connect(mapStateToProps, {
  closeSpelguide,
  openSpelguide,
  openTipsinfo,
  openXperten
})(ContextMenu);

 })(window);